import { graphql } from "@/types/gql";

export const QUERY_POLICIES = graphql(`
  query policiesByCityId($cityId: String!) {
    policiesByCityId(cityId: $cityId) {
      id
      curbPolicyId
      cityId
      name
      priority
      category
      rules {
        activity
        maxStay
        maxStayUnit
        noReturn
        noReturnUnit
        rate {
          rate
          endDuration
          incrementAmount
          incrementDuration
          rateUnit
          startDuration
          rateUnitPeriod
        }
        userClasses
      }
      timeSpans {
        startDate
        endDate
        daysOfWeek
        daysOfMonth
        months
        timeOfDayStart
        timeOfDayEnd
        designatedPeriod
        designatedPeriodExcept
      }
      color {
        dashed
        fillColor
        lineColor
        iconColor
      }
      publishedDate
    }
  }
`);

export const QUERY_CREATE_POLICY = graphql(`
  mutation createPolicy($createPolicyInput: CreatePolicyInput!) {
    createPolicy(createPolicyInput: $createPolicyInput) {
      id
      curbPolicyId
    }
  }
`);

export const QUERY_UPDATE_POLICY = graphql(`
  mutation updatePolicy($updatePolicyInput: UpdatePolicyInput!) {
    updatePolicy(updatePolicyInput: $updatePolicyInput) {
      id
    }
  }
`);

export const QUERY_REMOVE_POLICY = graphql(`
  mutation deletePolicy($policyId: String!) {
    deletePolicy(policyId: $policyId) {
      id
    }
  }
`);
